import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'

const database = new VuexORM.Database()

import models from './models/index'

models.forEach(item => database.register(item[0], item[1]))
Vue.use(Vuex)


const store = new Vuex.Store({
    plugins: [VuexORM.install(database, { namespace: 'e' })]
})

export default store
